var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { loading } from '../../../elements/Loading';
import { Form } from '../../../components';
import { FieldType } from '../../../elements';
import { rules } from '../../../helpers/Validation';
var HeadboardsForm = /** @class */ (function (_super) {
    __extends(HeadboardsForm, _super);
    function HeadboardsForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fields = [
            {
                name: 'name',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required()
                    .max(20),
                size: 4
            },
            {
                name: 'title',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .required()
                    .max(28),
                size: 4
            },
            {
                name: 'subtitle',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .max(40),
                size: 4
            },
            {
                name: 'line1',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .max(40),
                size: 4
            },
            {
                name: 'line2',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .max(40),
                size: 4
            },
            {
                name: 'telephone',
                type: FieldType.Text,
                rules: rules()
                    .string()
                    .max(40),
                size: 4
            },
        ];
        return _this;
    }
    HeadboardsForm.prototype.render = function () {
        var address = this.props.address;
        var headboardStore = this.props.store.headboardStore;
        return (React.createElement("div", null,
            React.createElement(Form, { loading: ['post@headboards/', 'put@headboards/'], fields: this.fields, values: address, store: headboardStore })));
    };
    HeadboardsForm = __decorate([
        inject('store'),
        loading(function (props) { return [
            props.match.params.id
                ? props.store.headboardStore.read(props.match.params.id).then(function (address) { return ({ address: address }); })
                : undefined,
        ]; }),
        observer
    ], HeadboardsForm);
    return HeadboardsForm;
}(Component));
export default HeadboardsForm;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Headboards/container/HeadboardsForm.tsx
// module id = 1595
// module chunks = 0